import { render, staticRenderFns } from "./Detail10.vue?vue&type=template&id=88f7c6e2&scoped=true&"
import script from "./Detail10.vue?vue&type=script&lang=js&"
export * from "./Detail10.vue?vue&type=script&lang=js&"
import style0 from "./Detail10.vue?vue&type=style&index=0&id=88f7c6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f7c6e2",
  null
  
)

export default component.exports